import { render, staticRenderFns } from "./ExpenseSupplementaryRecording.vue?vue&type=template&id=2eb4c49a&scoped=true&"
import script from "./ExpenseSupplementaryRecording.vue?vue&type=script&lang=js&"
export * from "./ExpenseSupplementaryRecording.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseSupplementaryRecording.vue?vue&type=style&index=0&id=2eb4c49a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb4c49a",
  null
  
)

export default component.exports